<header>
  <div class="header-section">
    <div class="title-section">
      <img src="assets/images/orange-logo.svg" alt="logo d'orange" />
      <h1>UpAssignations</h1>
    </div>
    <div *ngIf="activeRoute !== NavigationPath.Logout" class="nav-section">
      <div class="left-side">
        <nav>
          <a
            *ngIf="trackingTableIsEnabled()"
            (click)="redirectToTrackingTable()"
            [class.active-link]="activeRoute === '/tableau-de-suivi'"
            >Tableau de suivi</a
          >
          <a
            *ngIf="archivesIsEnabled()"
            (click)="redirectToArchives()"
            [class.active-link]="activeRoute === '/archives'"
            >Archives</a
          >
          <a
            *ngIf="logsTableIsEnabled()"
            (click)="redirectToLogsTable()"
            [class.active-link]="activeRoute === '/tableau-de-logs'"
            >Tableau de logs</a
          >
          <a
            *ngIf="notificationsCenterIsEnabled()"
            (click)="redirectToNotificationsCenter()"
            [class.active-link]="activeRoute === '/centre-de-notifications'"
            >Centre de notifications</a
          >
        </nav>
      </div>
      <div class="right-side">
        <div class="right-side-content">
          <div class="right-side-content-user">
            <lib-andromeda-menu
              #menu
              [closeOnSelection]="true"
              [disabled]="false"
            >
              <div menuTrigger>
                <span class="user-button">
                  <p>{{ userProfile?.userLabel }}</p>
                  <img src="assets/icons/drop-down.svg" alt="déplier" />
                </span>
              </div>
              <div menuContent>
                <ng-container *ngFor="let option of menuOptions">
                  <lib-andromeda-menu-option (click)="onClickOnOption(option)"
                    >{{ option.label }}
                    <img
                      *ngIf="option.label === UserMenuOption.Logout"
                      src="assets/icons/logout.svg"
                      alt="se deconnecter"
                    />
                  </lib-andromeda-menu-option>
                </ng-container>
              </div>
            </lib-andromeda-menu>
          </div>
          <div
            class="right-side-content-help-button"
            (click)="downloadUserGuide()"
          >
            Guide utilisateur
          </div>
        </div>
      </div>
    </div>
    <div
      class="downloading-container"
      *ngIf="(isDownloading$ | async) || (isDownloadComplete$ | async)"
    >
      <p
        class="downloading-container-is-downloading"
        *ngIf="isDownloading$ | async"
      >
        Le fichier est en cours de téléchargement...
      </p>
      <p
        class="downloading-container-is-download-complete"
        *ngIf="isDownloadComplete$ | async"
      >
        Le téléchargement est terminé !
      </p>
    </div>
  </div>
</header>
